import { render, staticRenderFns } from "./systemSettings.vue?vue&type=template&id=6dd52cf1&scoped=true&"
import script from "./systemSettings.vue?vue&type=script&lang=js&"
export * from "./systemSettings.vue?vue&type=script&lang=js&"
import style0 from "./systemSettings.vue?vue&type=style&index=0&id=6dd52cf1&lang=less&scoped=true&"
import style1 from "./systemSettings.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd52cf1",
  null
  
)

export default component.exports